import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const stats = [{
    value: '50+',
    label: 'Enterprise Clients'
  }, {
    value: '99.9%',
    label: 'Uptime'
  }, {
    value: '3x',
    label: 'Faster Deployment'
  }, {
    value: '24/7',
    label: 'Support'
  }];
  return <section id="about" className="py-24 bg-brand-black relative" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-15">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-16">
            <div className="inline-flex items-center gap-2 mb-4" data-id="element-17">
              <div className="w-8 h-1 bg-brand-primary rounded-full" data-id="element-18"></div>
              <h2 className="text-brand-primary font-semibold uppercase tracking-wider text-sm" data-id="element-19">
                Who We Are
              </h2>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-20">
              Pioneering AI Transformation Across Africa
            </h3>

            <div className="space-y-4 text-gray-400 text-lg leading-relaxed" data-id="element-21">
              <p data-id="element-22">
                Headquartered in Nairobi, Kenya, SpringLinks Solutions Ltd is a
                premium AI solutions company dedicated to empowering enterprises
                across the African continent.
              </p>
              <p data-id="element-23">
                As a certified partner of{' '}
                <span className="text-white font-medium" data-id="element-24">
                  SentientLogics AI
                </span>{' '}
                powered by{' '}
                <span className="text-white font-medium" data-id="element-25">Prisma AI</span>, we
                bring world-class artificial intelligence capabilities to local
                and regional businesses, ensuring they remain competitive in a
                rapidly evolving digital landscape.
              </p>
              <p data-id="element-26">
                We don't just build technology; we build strategic advantages.
                From generative AI to intelligent automation, our solutions are
                tailored to solve complex enterprise challenges.
              </p>
            </div>
          </motion.div>

          {/* Right Stats Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="grid grid-cols-2 gap-4 sm:gap-6" data-id="element-27">
            {stats.map((stat, index) => <motion.div key={index} whileHover={{
            y: -5,
            scale: 1.02
          }} className="glass-card p-8 rounded-2xl flex flex-col items-center justify-center text-center group hover:border-brand-primary/50 transition-all duration-300" data-id="element-28">
                <span className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-white to-gray-400 group-hover:from-brand-light group-hover:to-brand-primary transition-all duration-300 mb-2" data-id="element-29">
                  {stat.value}
                </span>
                <span className="text-sm text-gray-400 font-medium uppercase tracking-wide" data-id="element-30">
                  {stat.label}
                </span>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}